import 'es6-promise/auto'; // requirement to use vuex
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  devtools: true,
  state: {
    count: 0,
    displayPopMenu: true,
    displaySubMenus: false,
    displaySearchMenu: false,
    displayLayerMenu: false,
    displayLayerMenuButton: true,
    displaySettingsMenu: false,
    displayDetailView: false,
    displayLegendView: false,
    detailOrigin: undefined,
    currentMetrePerPixel: undefined,
    poi: {
      id: '',
      label: '',
      sublabel: '',
      meta: '',
      geometry: '',
      category: '',
      centerCoordinate: '',
      uri: '',
    },
    displayMap: true,
    bingMapStyle: 'Road',
    language: 'de',
    floorselect: false,
    bookmarks: true,
    currentHtmlAttributions: [],
    currentTextAttributions: [],
    legendItems: {
      chart: [],
      overlay: [],
    },
  },
  getters: {
    // eslint-disable-next-line
    // evenOrOdd: (state) => state.count % 2 === 0 ? 'even' : 'odd',
    // e.g. displaySearch: () => window.innerWidth > 760 ? true : displaySearchMenu,
    htmlAttributions: (state) => state.currentHtmlAttributions,
    textAttributions: (state) => state.currentTextAttributions,
  },
  mutations: {
    increment(state) {
      // eslint-disable-next-line
      state.count++;
    },
    showPopMenu() {
      this.state.displayPopMenu = true;
    },
    hidePopMenu() {
      this.state.displayPopMenu = false;
    },
    toggleSubMenus() {
      this.state.displaySubMenus = !this.state.displaySubMenus;
    },
    hideSubMenus() {
      this.state.displaySubMenus = false;
    },
    showSearchMenu() {
      this.state.displaySearchMenu = true;
      if (window.innerWidth < 450) {
        this.state.displayMap = false;
      }
    },
    showLayerMenu() {
      this.state.displaySubMenus = false;
      this.state.displayLayerMenu = true;
      if (window.innerWidth < 450) {
        this.state.displayMap = false;
      }
    },
    showSettingsMenu() {
      this.state.displaySettingsMenu = !this.state.displaySettingsMenu;
      if (window.innerWidth < 450) {
        this.state.displayMap = false;
      }
    },
    showLegendView() {
      this.state.displayLegendView = !this.state.displayLegendView;
      if (window.innerWidth < 450) {
        this.state.displayMap = false;
      }
    },
    closeFilterMenu() {
      this.state.displayFilterMenu = false;
      if (window.innerWidth < 450) {
        this.state.displayMap = true;
      }
    },
    closeSearchMenu() {
      if (window.innerWidth < 450) {
        this.state.displaySearchMenu = false;
        this.state.displayMap = true;
      }
    },
    closeLayerMenu() {
      this.state.displaySubMenus = true;
      this.state.displayLayerMenu = false;
      this.state.displayMap = true;
    },
    closeSettingsMenu() {
      this.state.displaySettingsMenu = false;
      this.state.displayMap = true;
    },
    showDetailView(state, poi) {
      this.state.poi = poi;
      if (window.innerWidth < 450) {
        this.state.displayMap = false;
      }
      this.state.displayLayerMenu = false;
      this.state.displayDetailView = true;
    },
    setDetailViewOrigin(state, origin) {
      this.state.detailOrigin = origin;
    },
    closeDetailView() {
      this.state.displayDetailView = false;
      this.state.displayMap = true;
    },
    closeDetailViewAndBackToSearch() {
      this.state.displayDetailView = false;
      this.state.displaySearchMenu = true;
    },
    closeLegendView() {
      this.state.displayLegendView = false;
      this.state.displayMap = true;
    },
    closeAllMenus() {
      this.state.displayFilterMenu = false;
      this.state.displayLayerMenu = false;
      this.state.displaySettingsMenu = false;
      this.state.displayDetailView = false;
      this.state.displayLegendView = false;
      this.state.displayMap = true;
      if (window.innerWidth > 1250) {
        this.state.displaySubMenus = true;
        this.state.displaySearchMenu = true;
      } else {
        this.state.displaySearchMenu = false;
        this.state.displaySubMenus = false;
      }
    },
    changeBingStyleTo(bing) {
      this.state.bingMapStyle = bing.style;
    },
    // TODO implement these:
    enterModeMobile() {
    },
    enterModeTablet() {
    },
    enterModeDesktop() {
    },
    changeLanguage(lang) {
      this.state.language = lang;
      // eslint-disable-next-line no-console
      console.log(`Language: ${lang}`);
    },
    toggleFloorselect() {
      this.state.floorselect = !this.state.floorselect;
    },
    toggleBookmarks() {
      this.state.bookmarks = !this.state.bookmarks;
    },
    addToHtmlAttributionList(state, attr) {
      if (!this.state.currentHtmlAttributions.includes(attr)) {
        this.state.currentHtmlAttributions[this.state.currentHtmlAttributions.length] = attr;
      }
    },
    removeFromHtmlAttributionList(state, attr) {
      // eslint-disable-next-line max-len
      this.state.currentHtmlAttributions = this.state.currentHtmlAttributions.filter((el) => el !== attr);
    },
    addToTextAttributionList(state, attr) {
      if (!this.state.currentTextAttributions.includes(attr)) {
        this.state.currentTextAttributions[this.state.currentTextAttributions.length] = attr;
      }
    },
    removeFromTextAttributionList(state, attr) {
      // eslint-disable-next-line max-len
      this.state.currentTextAttributions = this.state.currentTextAttributions.filter((el) => el !== attr);
    },
    updateCurrentMetrePerPixel(state, attr) {
      this.state.currentMetrePerPixel = attr;
    },
    addLegendItem(state, input) {
      const { layername } = input;
      const { item } = input;
      const { type } = input;
      const me = this;
      const checkIfLayerExists = me.state.legendItems[type].findIndex((e) => e.layer === layername);
      if (checkIfLayerExists >= 0) {
        const checkIfLegendExists = me.state.legendItems[type][checkIfLayerExists].legends.findIndex((e) => e === item);
        if (checkIfLegendExists === -1) {
          me.state.legendItems[type][checkIfLayerExists].legends.push(item);
        } // else legend entry exists
      } else {
        me.state.legendItems[type].push({ layer: layername, legends: [item] });
      }
    },
  },
});
export default store;
